module.exports = __webpack_public_path__ + "static/media/siddharth-nandi-hills-trip-banner.b9e544c8.jpg";